module.exports = __webpack_public_path__ + "static/media/fleche.d3f35870.png";